export const settingsTranslationsServerModel = data => ({
  object_id: data?.object_id || '',
  property_name: data?.property_name || '',
  translated_value: data?.translated_value || ''
})